import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, Switch,
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, Grid, GridItem } from "@chakra-ui/react";
  import { TopDisplay,UploadButton } from "../../../../components";
  import { IoMdAdd as AddIcon } from "react-icons/io";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState, useEffect } from "react";
  import styled from "@emotion/styled";
  import {TopLink} from '../';
  import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
  import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
  import { atom, useAtom } from 'jotai';
  import { Formik,Form,Field } from "formik";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import apiCall from '../../../../utils/apiCall';
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import { format, setDate } from "date-fns";
  import * as Yup from 'yup';
  import moment from "moment";
  import { Loader } from "../../../../customs";
  import {TablePopUp, DateFilter} from '../../../../components';
  import ReactPaginate from 'react-paginate';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import { IoReloadCircleOutline as ResetIcon} from "react-icons/io5";
  
  
  
  const HeadStyle={
    borderBottom:"1px solid var(--cipm-light-green)",
    padding:'15px 5px',
    color:'var(--dark-green-color)',
  }
  
  const DataStyle = {
    padding:'5px 5px',
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type > *{
      display:none;
    }
    :hover > td{
      background-color:var(--table-highlight);
      &:last-of-type > *{
        display:block;
      }
    } 
    &.active > td:last-of-type > *{
      display:block !important;
    }  
  `
  const PhotocardPeriodSetUpAtom = atom<number | null>(null);
  
  export default function PhotocardPeriodSetUp() {
    const [hide,set_hide] = useState<boolean>(true);
    const [active] = useAtom<number | string | null>(PhotocardPeriodSetUpAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);

    const {data:allExamPeriod} = useQuery(['exam-period'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
        select(data){
         
          return data.data.Data;
        },
      });
  
    const {isLoading,data:photocardDuration} = useQuery(["Photocard-duration"],{
      queryFn: async ()=> await apiCall().get(`/exam/setup/photoCardDuration`),
      select: (data) => data?.data?.Data,
      onSuccess(data) {
          //console.log(data,'Fee period data')
      },
    })
    const [search,set_search] = useState('');
    const [filter_data,set_filter_data] = useState<any>(photocardDuration);
  
    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data(photocardDuration)
      }
      else set_filter_data(photocardDuration)
    }
    const itemsPerPage = 10;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
    const handleDateFilter = (obj:any) =>{
      const {start,end} = obj; 
      //console.log(obj,'start end');
      const s_date:number = new Date(start.concat("T00:00:00") || null)?.getTime();
      const e_date:number = new Date(end.concat("T00:00:00") || null)?.getTime();
      //console.log(s_date,e_date,'date in seconds')
      const tempData:any = photocardDuration;
      let f_data = tempData.filter((eData:any)=>{
        let e_date_time:number = new Date(eData?.ExamDateTime?.split('.')[0] || null)?.getTime();
       // console.log(e_date_time,'time in seconds')
        return e_date_time >= s_date && e_date_time <= e_date;
      })
     // console.log(f_data,'date filtered data')
      if(f_data.length > 0)set_filter_data(f_data);
      else set_filter_data(photocardDuration);
    }
  
     useEffect(()=>{
      set_filter_data(photocardDuration)
    },[photocardDuration])
  
    const handleAddPhotocardPeriod = () =>{
        set_modal({
          header:'Photocard Period Setup',
          content:<AddType />
        })
        set_open(true);
        // set_notification({
        //   type:'success',
        //   message: 'Added Successfully'
        // })
        // set_Nopen(true);
    }
  
    const getFeeType = (Id:number | undefined) =>{
      return allExamPeriod && allExamPeriod.length > 0?allExamPeriod.find((eType:any )=> eType.Id === Id)?.Name:''
    }
       
     
    return (
      <>
      {isLoading?<Loader />:
  
      <Box>
        <TopLink />
        <TopDisplay label="Photocard Period SetUp" button_array={[
  
            <Button onClick={handleAddPhotocardPeriod} bg="var(--dark-green-color)" color="var(--white-color)"  type="button" leftIcon={<AddIcon/>}>Add Photocard Period</Button>
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
              <span style={{position:'absolute',zIndex:'1',
              right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
            </InputGroup>
            <DateFilter onChange = {handleDateFilter}/>
            <Button onClick={()=>{set_filter_data(photocardDuration);set_search('')}} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<ResetIcon/>}>Reset Filter</Button>
  
           {/* <Select placeholder="Date Range" width="150px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)">
            </Select>*/}
            
  
          </Flex>
          <Flex mt="25px" flexDir="column" gap="10px">
            {/* <Heading m="0" fontSize="1rem">All Candidates</Heading> */}
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
        
       {  filter_data && filter_data.length > 0 ? <TableContainer sx={{overflowY:'visible',h:'max-content'}}  mt="20px">
            <Table sx={{overflowY:'visible'}} size='sm'>
              <Thead>
                <Tr >
                  <Th sx={HeadStyle}>Start Date</Th>
                  <Th sx={HeadStyle}>End date</Th>
                  <Th sx={HeadStyle}>Exam Period</Th>
                  <Th sx={HeadStyle} w="50px" ></Th>
                </Tr>
              </Thead>
              <Tbody sx={{overflowY:'visible'}}>
                {currentItems.map((ephotosetup:any,index:number) =><ROWSTYLE className={ephotosetup.Id === active?'active':''} key={ephotosetup.Id}>
                  <Td sx={DataStyle}>{format(new Date(ephotosetup.StartDate), "dd/MM/yyyy")}  <br />
                  {format(new Date(ephotosetup.StartDate), "hh:mm a")}</Td>
                  <Td sx={DataStyle}>{format(new Date(ephotosetup.EndDate), "dd/MM/yyyy")}  <br />
                  {format(new Date(ephotosetup.EndDate), "hh:mm a")}</Td>
                  <Td sx={DataStyle}>{allExamPeriod && allExamPeriod.find((ePeriod:any)=> ePeriod.Id == ephotosetup.ExamPeriodId)?.ExamName || ''}</Td>
                  <Td sx={DataStyle} w="50px" h="50px">
                    <TempPopUp index={ephotosetup.Id} data={ephotosetup}/>
                  </Td>
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Photocard period setup'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
    }
      </>
      
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  // const AddSchema = Yup.object().shape({
  //   FeeName:Yup.string().required(),
  //   StartDate:Yup.date().required(),
  //   EndDate:Yup.date().min(Yup.ref('StartDAte'),'End Date cannot be less than start Date'),
  // })
  
  const validateDateRange = (obj:any) => {
    const { StartDate, EndDate} = obj;
    if (!StartDate || !EndDate) {
      return true; // don't validate if either field is missing
    }
    return moment(EndDate).isSameOrAfter(StartDate); // custom validation logic
  };
  
  const AddSchema = Yup.object({
    StartDate: Yup.date().required(),
    EndDate:Yup.date().required(),
    ExamPeriodId:Yup.number().required(),
    // EndDate: Yup.date().test('date-range', 'End date must be after start date', ()=>validateDateRange({StartDate:Yup.ref("StartDate"),EndDate:Yup.ref('EndDate')})).nullable(),),
  });
  
  const AddType = (props:any) =>{
    // console.log({...props},'data')
    const queryClient = useQueryClient();
    const [,set_open] = useAtom(openAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const {data:allExamPeriod} = useQuery(['exam-period'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
        select(data){
          return data.data.Data;
        },
      })
    const {mutate:addUpdate,isLoading} = useMutation({
      mutationKey:['new-photocard-setup'],
      mutationFn:async (data:any)=> {
        return props && props?.Id?await apiCall().put(`/exam/setup/photoCardDuration/${props.Id}`,data):await apiCall().post(`/exam/setup/photoCardDuration`,data)},
      onSuccess:(data)=>{
        console.log(data,'new data')
        set_notification({
          type:'success',
          message:data?.data?.Message || ' Photocard Duration Added Successfully'
        })
        set_Nopen(true);
        queryClient.invalidateQueries({
          queryKey:['photocard-duration']
        })
      },
      onError(error:any){
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
    } )
    // console.log(allFeeType,'all fee type')
    return (
      <>
        <Formik
            initialValues={{
              StartDate:props.StartDate || '',
              EndDate:props.EndDate || '',
              ExamPeriodId:props.ExamPeriodId || '',
            }}
            validationSchema={AddSchema}
            onSubmit={(values:any) => {
              //console.log('clicked')
              const data = {
                StartDate:values.StartDate,
                EndDate:values.EndDate,
                ExamPeriodId:values.ExamPeriodId,
              };
              // console.log(data,'form data')
  
              addUpdate(data);
            }}
          >
           {(formik:any)=>{
          const {errors,values} = formik;
          // console.log(values,'values');
          // console.log(errors,'errors')
          return (
              <Form>
                <Flex flexDir={"column"} align={"center"} gap="20px"> 
                <Field as={Select}
                  bg='var(--white-color)'
                  borderColor='var(--dark-green-color)'
                  color='var(--dark-green-color)'
                  placeholder='Exam Period'
                  name="ExamPeriodId"
                >
                 {allExamPeriod && allExamPeriod.length > 0 ?
                    allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                  :'0'}
                </Field>
                  <Box width="100%">
                    Start Date <br/>
                    <Input as={Field}
                      placeholder="Select Date and Time"
                      size="md"
                      name="StartDate"
                      type="datetime-local"
                    />
                  </Box>
                  <Box w="100%">
                    End Date <br/>
                    <Input as={Field}
                      placeholder="Select Date and Time"
                      size="md"
                      name="EndDate"
                      type="datetime-local"
                    />
                  </Box>
                  <Box color="red" fontSize=".7rem">
                    {errors && Object.values(errors).map((error:any,index:number) => <Box key={index}>{error}</Box>)}
                  </Box>
                  <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)" >
                    {isLoading?"Loading":'Submit'}
                  </Button>
                </Flex>
                  
                
              </Form>
            )}}
          </Formik>
      </>
    )
  }
  
  const TempPopUp = (props:any) =>{
    const index = props.index;
    const data = props.data;
    const [active,set_active] = useAtom(PhotocardPeriodSetUpAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_Nopen] = useAtom(openNAtom);
    const [,set_notification]= useAtom(notificationAtom);
    const queryClient = useQueryClient();
    // const {mutate:deleteFee,isLoading} = useMutation({
    //   mutationKey:['delete-Fee-period'],
    //   mutationFn:async () => await apiCall().get(`/exam/setup/examFee/${data?.Id}/delete`),
    //   onSuccess(data:any) {
    //     queryClient.invalidateQueries({queryKey:["fee-period"]})
    //     set_notification({
    //       type:'success',
    //       message:data?.data?.Message || 'Deleted Successfully'
    //     })
    //     set_Nopen(true);
    //   },
    //   onSettled(){
    //     set_open(false);
    //   }
    // })
  
    const handleClick = () =>{
      if(index === active){
        set_active(null);
        return;
      }
      else{
        set_active(index);
      }
    }
    const handleView= () =>{
      set_modal({
        header:'View Fee SetUp',
        content:<Grid>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <span>Exam Period</span>
            <span>{data?.ExamPeriodId}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <span>Start Date</span>
            <span>{format(new Date(data?.StartDate), "dd/MM/yyyy")}</span>
          </GridItem>
          <GridItem as={Flex} justify="space-between" p="10px 0">
            <span>End Date</span>
            <span>{format(new Date(data?.EndDate), "dd/MM/yyyy")}</span>
          </GridItem>
         
        </Grid>
      })
      set_open(true);
      handleClick();
    }
    const handleEdit = () =>{
      handleClick();
      set_modal({
        header:'Edit Photocard period SetUp',
        content:<AddType {...data}/>
      });
      set_open(true);
      handleClick();
      
    }
    // const handleDelete = () =>{
    //   set_modal({
    //     header:'Delete Fee SetUp',
    //     content:<Grid gap="20px">
    //       <GridItem>Are you Sure you want to delete this fee Setup</GridItem>
    //       <GridItem as={Flex} justify="space-between" p="20px 0">
    //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
    //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
    //         <Button disabled={isLoading} 
    //           variant="outline" bg="var(--white-color)"
    //           onClick={()=>set_open(false)}
    //           border="1px solid var(--dark-green-color)"
    //           color="var(--dark-green-color)" >Cancel</Button>
    //       </GridItem>
    //     </Grid>
    //   });
    //   set_open(true);
    // }
    
    return (
      <TablePopUp click={handleClick} options={[
        {label:'View Photocard SetUp',click:handleView},
        {label:'Edit Photocard SetUp',click:handleEdit},
        // {label:'Delete Fee SetUp',click:handleDelete}
      ]} />
    )
  }
  
  
  